import * as React from "react";
import {
  Center,
  Container,
  Grid,
  GridItem,
  Heading,
  VStack,
  Text,
  SimpleGrid,
} from "@chakra-ui/react";
import { Link } from "gatsby";
import GlobalNav from "./global-nav";

const Layout = ({ children }) => {
  return (
    <Grid
      templateAreas={{
        base: `
              "header"
              "main"
              "nav"
              "footer"
            `,
        md: `
              "header header"
              "main main"
              "footer footer"
            `,
      }}
      gridTemplateRows={{
        base: "auto 1fr auto auto",
        md: "auto 1fr auto",
      }}
      gridTemplateColumns={{
        base: "1fr",
        md: "3fr 1fr",
      }}
      gap={4}
      minH={"100vh"} // 画面の高さいっぱいにする
    >
      <GridItem pl={2} area={"header"}>
        <Center>
          <Link to="/">
            <Heading as="h1" fontFamily={"'ヒラギノ明朝 ProN', 'serif'"}>
              ショピトレ
            </Heading>
          </Link>
        </Center>
        <GlobalNav />
      </GridItem>
      <GridItem pl={2} area={"main"}>
        <Container maxW="container.lg">{children}</Container>
      </GridItem>
      <GridItem pl={2} area={"footer"}>
        <VStack>
          <Text>© 2021 ショピトレ</Text>
          <SimpleGrid columns={2} spacing={4}>
            <Link to="/privacy-policy">プライバシーポリシー</Link>
            <Link to="/form">お問い合わせ</Link>
          </SimpleGrid>
        </VStack>
      </GridItem>
    </Grid>
  );
};

export default Layout;
